import { render } from "./imgPreviewModal.vue?vue&type=template&id=3de577d3&scoped=true&ts=true"
import script from "./imgPreviewModal.vue?vue&type=script&lang=ts"
export * from "./imgPreviewModal.vue?vue&type=script&lang=ts"

import "./imgPreviewModal.vue?vue&type=style&index=0&id=3de577d3&scoped=true&lang=css"

import exportComponent from "C:\\projects\\equistasi\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3de577d3"]])

export default __exports__